/**
 * @generated SignedSource<<97c5fc4d56270be8cab860938341ed8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSystemCardRulesRelayQuery$variables = {
  id: string;
};
export type useSystemCardRulesRelayQuery$data = {
  readonly getSystem: {
    readonly allowRentalWithoutCard: boolean | null | undefined;
    readonly id: string;
    readonly requireCreditCard: boolean | null | undefined;
  } | null | undefined;
};
export type useSystemCardRulesRelayQuery = {
  response: useSystemCardRulesRelayQuery$data;
  variables: useSystemCardRulesRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "System",
    "kind": "LinkedField",
    "name": "getSystem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "requireCreditCard",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowRentalWithoutCard",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSystemCardRulesRelayQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSystemCardRulesRelayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dfb5eca2de3ef547e933c999c74903dc",
    "id": null,
    "metadata": {},
    "name": "useSystemCardRulesRelayQuery",
    "operationKind": "query",
    "text": "query useSystemCardRulesRelayQuery(\n  $id: ID!\n) {\n  getSystem(id: $id) {\n    id\n    requireCreditCard\n    allowRentalWithoutCard\n  }\n}\n"
  }
};
})();

(node as any).hash = "24766095b1a984afdd84c04807f4a8c0";

export default node;
